import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from './store';
import './i18n';
import {initKeycloak, keycloak} from "./keycloak/keycloak";
import {INIT_AUTH_FAILED} from "./store/auth/actions/auth-actions";

initKeycloak.then(authenticated => {
    if (authenticated) {
        store.dispatch({ type: 'INIT_AUTH' });
        store.dispatch({ type: 'INIT_AUTH_COMPLETE' });
        store.dispatch({ type: 'REFRESH_TOKEN' });
    } else {
        keycloak.login({
            redirectUri: window.location.origin + '/dashboard'
        }).catch(err => {
            console.error("Keycloak login failed:", err);
            store.dispatch({type: INIT_AUTH_FAILED})
        });
    }

    ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
            <Provider store={store}>
                <App/>
            </Provider>
        </React.StrictMode>
    );
}).catch(reason => {
    console.error(reason)
    store.dispatch({type: INIT_AUTH_FAILED})
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
